import request from '@/utils/request';

export function fetchCustomerList(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/customers`,
    method: 'get',
    params
  });
}

export function fetchDeliveryList(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/deliverableApps`,
    method: 'get',
    params
  });
}
export function createCustomer(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/customers`,
    method: 'post',
    data: {
      customerName: params.customerName,
      contactName: params.contactName,
      contactPhone: params.contactPhone,
      headOrg: params.headOrg,
      headUser: params.headUser
    }
  });
}


export function updateCustomer(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/customers/${params.customerID}`,
    method: 'put',
    data: {
      customerName: params.customerName,
      contactName: params.contactName,
      contactPhone: params.contactPhone,
      headOrg: params.headOrg,
      headUser: params.headUser
    }
  });
}

export function deleteCustomer(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/customers/${params.customerID}`,
    method: 'delete'
  });
}




// WEBPACK FOOTER //
// ./src/api/customer.js